import React, { useCallback, useMemo } from 'react';
import size from 'lodash/size';
import { InfiniteScroll } from '@yme/atoms/infinite-scroll';
import { useWindowSize } from '@yme/hooks/index';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { ContentGrid } from './ContentGrid';
import { INFINITE_SCROLL_OFFSET_DESKTOP, INFINITE_SCROLL_OFFSET_MOBILE } from './constants';
import { getCountLineVisible, countSymbolsInLine } from './helpers';
import { mockText } from './mockData';
export function ContentGridWrapper({ isRightToLeft, isLoaded, contentItems, autoCorrectQueryResult, numFound = 0, query = '', category = '', wrapperWidth = 0, language = '', getContentData, }) {
    const { isMobileView, isTabletView } = useWindowSize();
    const sizeContentItems = size(contentItems);
    const isAllItemsLoaded = sizeContentItems === numFound;
    const fetchMoreProducts = useCallback(() => {
        if (!isAllItemsLoaded) {
            getContentData(autoCorrectQueryResult || query, category, sizeContentItems, true);
        }
    }, [isAllItemsLoaded, getContentData, autoCorrectQueryResult, query, category, sizeContentItems]);
    const symbolsInLine = useMemo(() => countSymbolsInLine(mockText, wrapperWidth, 'Ubuntu', '16px'), [wrapperWidth]);
    return (React.createElement(FlexWrapper, { flexDirection: "column", mb: INDENT.xxl, mbTablet: INDENT.xxxl, mbDesktop: INDENT.xxxxl },
        React.createElement(InfiniteScroll, { onReachEnd: fetchMoreProducts, offset: isMobileView ? INFINITE_SCROLL_OFFSET_MOBILE : INFINITE_SCROLL_OFFSET_DESKTOP },
            React.createElement(ContentGrid, { autoCorrectQueryResult: autoCorrectQueryResult, query: query, category: category, language: language, countLineVisible: getCountLineVisible(isMobileView, isTabletView), symbolsInLine: symbolsInLine, isRightToLeft: isRightToLeft, isLoaded: isLoaded, contentItems: contentItems }))));
}
